import * as actions from '../../actions/actiontypes';
import initialstate from '../initialstate';
import Utility from '../../util/utilityfunctions';

export default function bulkfilterreducer(state = initialstate.bulkFilter, action) {
	switch (action.type) {
		case actions.SET_BULK_FILTERS: {
			if (action.filter) {
				let filters = {};
				if (action.quickFilters && _.size(action.quickFilters) > 0) {
					let existingFilters = { ...state };
					filters = removeExistingFilters(existingFilters, action.quickFilters, action.key);
				}
				else {
					filters = { ...state };
				}
				let result = {
					...filters,
					[action.key]: {
						...filters[action.key],
						[action.filter.name]: {
							...action.filter,
							value: action.value
						}
					}
				};

				if (!Utility.hasValue(result[action.key][action.filter.name].value)) {
					delete result[action.key][action.filter.name].value;
				}

				return result;
			} else {
				return {
					...state,
					[action.key]: action.value
				};
			}
		}

		case actions.SET_BULK_MULTIPLE_FILTERS: {
			if (action.filters) {
				let newFilters = {};
				_.forEach(action.filters, (item) => {
					newFilters[item.name] = item;
				});

				let result = {
					...state,
					[action.key]: {
						...state[action.key],
						...newFilters
					}
				};

				_.forEach(action.filters, (item) => {
					if (!Utility.hasValue(result[action.key][item.name].value)) {
						delete result[action.key][item.name];
					}
				})

				return result;
			} else {
				return { ...state };
			}
		}

		case actions.UPDATE_BULK_FILTER: {
			if (action.filter) {
				let updatedFilter = {};
				updatedFilter[action.filtername] = action.filter;

				let result = {
					...state,
					[action.key]: {
						...state[action.key],
						...updatedFilter
					}
				};

				if (!Utility.hasValue(result[action.key][action.filtername].value)) {
					delete result[action.key][action.filtername];
				}

				return result;
			} else {
				return { ...state };
			}
		}

		case actions.CLEAR_BULK_ALL_FILTERS: {
			if (action.parentName) {
				return {};
			} else {
				return {...state};
			}
		}

		case actions.CLEAR_BULK_FILTERS: {
			if (!action.parentName) {
				let result = {...state};
				delete result[action.key];
				return result;
			} else {
				let result = {...state[action.key]};

				Object.entries(result).forEach((filter) => {
					if (
						!filter[1].appliesTo ||
						(filter[1].appliesTo && filter[1].appliesTo.some((item) => item === action.parentName))
					) {
						delete result[filter[0]];
					}
				});

				return {
					...state,
					[action.key]: result
				};
			}
		}

		default:
			return state;
	}
}

// If filter is applied from main menu, ensure to remove existing filters of quick filter selection
const removeExistingFilters = (existingFilters, quickFilters, keyName) => {
	let filters = {...existingFilters[keyName]};
	let filtersToApply = {...existingFilters[keyName]};
	if(filters && _.size(filters) > 0){
		const keys = Object.keys(quickFilters);
		const existingKeys = Object.keys(filters);
		if(keys.length > 0 && existingKeys.length > 0) {
			_.forEach(existingKeys, (k) => {
				if(keys.includes(k)) {
					const quickFilterValue = quickFilters[k];
					let validValues = filters[k].value.filter(i => !quickFilterValue.includes(i));
					if(validValues.length > 0) {
						filtersToApply[k] = { ...filters[k], value: validValues };
					}
					else {
						delete filtersToApply[k];
					}
				}
			});
		}
	}
	return {
		...existingFilters,
		[keyName]: filtersToApply
	};
}
